import React from 'react';

import { AdminUsersPanel } from '../../../components/AdminUsersPanel';

export const UsersPanel = ({ organization }) => {
  return <AdminUsersPanel users={organization.users} />;
};
